import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';

export interface CommonDialogData {
  heading: string;
  data: any[];
  displayColumns: string[];
  labelData: { [key: string]: string }; 
}

@Component({
  selector: 'app-common-list-dialog',
  standalone: true,
  templateUrl: './common-list-dialog.component.html',
  styleUrls: ['./common-list-dialog.component.scss'],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule
  ],
})
export class CommonListDialogComponent {
  dataSource: MatTableDataSource<any>;
  displayColumns: string[];
  labelData: { [key: string]: string };
  heading: string;
  selectedRowIndex: number | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CommonDialogData,
    private dialogRef: MatDialogRef<CommonListDialogComponent>
  ) {
     this.dataSource = new MatTableDataSource(data.data || []);
    this.displayColumns = data.displayColumns;
    this.labelData = data.labelData;
    this.heading = data.heading;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  confirmSelection() {
    this.dialogRef.close(
      this.selectedRowIndex !== null
        ? this.dataSource.data[this.selectedRowIndex]
        : null
    );
  }

  selectRow(index: number) {
    this.selectedRowIndex = index;
  }
}
